// OpenerCloser.tsx
import React, {useState } from "react";
import OpenerCloserContent from "./OpenerCloserContentComponent";
import {Box} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import {OpenerCloserObject} from "../../../types/opernerCloserTypes";

interface OpenerCloserInterface {
    selectedOpener: OpenerCloserObject;
    setSelectedOpener: (opener: OpenerCloserObject) => void;
    selectedCloser: OpenerCloserObject;
    setSelectedCloser: (closer: OpenerCloserObject) => void;
    selectedItemsCompetitions: Competition[];
    multi_event: boolean;
    dynamicCompetitions: boolean;
    selectedCompetition: any;
    setSelectedCompetition: any;
    isCollapseOpen: boolean;
}

export interface Competition {
    id: string | undefined;
    name: string;
    type: string;
    season: string;
}

export const defaultCompetition: Competition = { id: undefined, name: "", type: "", season: "" };

const OpenerCloser = ({
                          selectedOpener,
                          setSelectedOpener,
                          selectedCloser,
                          setSelectedCloser,
                          selectedItemsCompetitions,
                          multi_event,
                          dynamicCompetitions,
                          selectedCompetition,
                          setSelectedCompetition,
                          isCollapseOpen
                      }: OpenerCloserInterface) => {

    const theme = useTheme();
    const [isOpenOpener, setIsOpenOpener] = useState<string | false>(false);
    const [isOpenCloser, setIsOpenCloser] = useState<string | false>(false);

    const handleClick = (panel: "opener" | "closer") => (_: any, expanded: boolean) => {
        if (panel === "opener") {
            setIsOpenOpener(expanded ? "opener" : false);
        } else {
            setIsOpenCloser(expanded ? "closer" : false);
        }
    };

    return (
            <Box sx={{display: 'flex', justifyContent: 'space-between', flexDirection: 'row'}}>
                <Box width={'100%'} paddingRight={theme.spacing.sm}>
                    <OpenerCloserContent type={"opener"} isOpen={isOpenOpener} onClick={handleClick('opener')} multi_event={multi_event} selectedItemsCompetitions={selectedItemsCompetitions} selectedOpener={selectedOpener} setSelectedOpener={setSelectedOpener}
                                         selectedCompetition={selectedCompetition} setSelectedCompetition={setSelectedCompetition} need_dropdown={true} isCollapseOpen={isCollapseOpen} dynamicCompetitions={dynamicCompetitions}

                    />
                </Box>
                <Box width={'100%'} paddingRight={theme.spacing.sm}>
                    <OpenerCloserContent type={"closer"} isOpen={isOpenCloser} onClick={handleClick('closer')} multi_event={multi_event} selectedItemsCompetitions={selectedItemsCompetitions} selectedCloser={selectedCloser}
                                         setSelectedCloser={setSelectedCloser}
                                         selectedCompetition={selectedCompetition} setSelectedCompetition={setSelectedCompetition} need_dropdown={false} isCollapseOpen={isCollapseOpen} dynamicCompetitions={dynamicCompetitions}/>
                </Box>
            </Box>
    );
};

export default OpenerCloser;
